import React from 'react';
import { Column } from '../../components/column';
import { mobileFullWidthColumnClassName } from '../../utils/defaults';
import { Spacer } from '../../components/spacer';
import { ItemButton } from './item-button';
import { ItemDescription } from './item-description';
import { ItemImage } from './item-image';
import { ItemPrice } from './item-price';
import { ItemTitle } from './item-title';
import { itemGridColumn, itemGridSpacer } from './css-classes';
export const ItemsColumn = ({ section, item, padding, width, experiments }) => {
    return (React.createElement(Column, { padding: padding, cssClass: `${itemGridColumn} ${mobileFullWidthColumnClassName}`, width: width }, item && (React.createElement(React.Fragment, null,
        React.createElement(ItemImage, { item: item, spaceForColumn: section.spaceForColumn }),
        section.show?.title !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
        React.createElement(ItemTitle, { section: section, item: item }),
        section.show?.description !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
        React.createElement(ItemDescription, { section: section, item: item }),
        section.show?.price !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
        React.createElement(ItemPrice, { section: section, item: item }),
        section.show?.button !== false && (React.createElement(Spacer, { cssClass: itemGridSpacer, height: `${section.spacerHeight}px` })),
        React.createElement(ItemButton, { section: section, item: item, experiments: experiments })))));
};
//# sourceMappingURL=item-column.js.map